$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('dialog-simple')) {
    customElements.define(
      'dialog-simple',
      class DialogSimple extends HTMLElement {
        constructor() {
          super();
        }

        static get observedAttributes() {
          return ['data-show', 'data-title', 'data-desc', 'data-button-text', 'data-button-link', 'data-img'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (oldValue === newValue) return;

          switch (name) {
            case 'data-show':
              newValue === 'true' ? $(this).show() : $(this).hide();
              // $('body').css('overflow', newValue === 'true' ? 'hidden' : 'auto');
              if (newValue === 'true') {
                // 禁用body滚动
                window.litime.disableScroll();
              } else {
                // 启用body滚动
                window.litime.enableScroll();
              }
              break;
            case 'data-title':
              $(this)
                .find('.dialog-title')
                .text(newValue || '');
              break;
            case 'data-desc':
              $(this)
                .find('.dialog-desc')
                .html(newValue || '');
              break;
            case 'data-button-text':
              $(this).find('.dialog-button a').text(newValue);
              break;
            case 'data-button-link':
              const buttonContainer = $(this).find('.dialog-button');
              const buttonEl = buttonContainer.find('a');
              if (newValue) {
                buttonEl.attr('href', newValue);
                buttonContainer.show();
              } else {
                buttonContainer.hide();
              }
              break;
            case 'data-img':
              const imgContainer = $(this).find('.dialog-img');
              if (newValue) {
                imgContainer.attr('src', newValue);
                imgContainer.show();
              } else {
                imgContainer.hide();
              }
              break;
          }
        }

        connectedCallback() {
          const dialog = this;
          const close = $(dialog).find('.dialog-close');

          close.on('click', () => {
            this.setAttribute('data-show', 'false');
          });
          this._initializeContent();
        }

        _initializeContent() {
          const title = this.getAttribute('data-title');
          const desc = this.getAttribute('data-desc');
          const buttonText = this.getAttribute('data-button-text');
          const buttonLink = this.getAttribute('data-button-link');
          const img = this.getAttribute('data-img');

          $(this)
            .find('.dialog-title')
            .text(title || '');
          if (desc) $(this).find('.dialog-desc').html(desc);
          if (buttonText) $(this).find('.dialog-button a').text(buttonText);
          if (buttonLink) {
            const buttonContainer = $(this).find('.dialog-button');
            const buttonEl = buttonContainer.find('a');
            buttonEl.attr('href', buttonLink);
            buttonContainer.show();
          } else {
            $(this).find('.dialog-button').hide();
          }
          if (img) {
            const imgEl = $(this).find('.dialog-img');
            imgEl.attr('src', img);
            imgEl.show();
          } else {
            $(this).find('.dialog-img').hide();
          }
        }
      }
    );
  }
});
